export const CONFIRM_EMAIL = "confirmEmail";
export const CANCEL_EMAIL = "cancelEmail";
export const LIST_EVENT = "listEvent";
export const CANCEL_EVENT = "cancelEvent";
export const SUMMARIZE_EVENT = "summarizeEvent";
export const ADD_RESERVATION = "addReservation";
export const SET_RESERVER_INFO = "setReserverInfo";
export const LIST_SURVEY_QUESTION = "listSurveyQuestion"
